import { Injectable } from "@angular/core";
import { Theme, themeFolder } from "main/enums/theme.enum";
import { IdentityService, UsersService } from "identity";

const DARK_THEME_BODY_CLASS = 'theme-dark';

@Injectable({
        providedIn: 'root',
})
export class UserSettingsService {

    get CurrentTheme(): Theme {
        if(!this.identityService.user){
            return Theme.Default;
        }
        return this.identityService.user?.UserSettings.theme;
    }

    constructor(private userService: UsersService, private identityService: IdentityService) {
        this.identityService.onLogin.subscribe(() => this.applyActiveTheme());
        if (this.identityService.user) {
            this.applyActiveTheme();
        }
    }


    setTheme(theme: Theme): void {
        this.identityService.user.UserSettings.theme = theme;
        this.applyActiveTheme();
        this.userService.updateUserSettings(this.identityService.user).subscribe(
            data => {
            },
            error => {
                console.error("Error updating user settings: ", error);
            }
        );
    }

    applyActiveTheme(): void {
        let link = document.getElementById('theme') as HTMLLinkElement | null;
        if (!link) {
            link = document.createElement('link');
            link.id = 'theme';
            link.rel = 'stylesheet';
            document.head.appendChild(link);
        }
        link.href = `dist/assets/primeng-themes/${themeFolder(this.CurrentTheme)}/theme.css`;
        // Keep the link at the end of <head> so its rules win the cascade
        // against the dist/styles.<hash>.css bundle (which the MVC layout
        // injects via @section scripts at the end of <body>).
        document.head.appendChild(link);

        document.body.classList.toggle(DARK_THEME_BODY_CLASS, this.CurrentTheme === Theme.Dark);
    }
}
